// project import
import { useEffect, useRef } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import CommonToast from 'components/commons/Toast';
import { getShopList } from 'services/auth';
import { LS_AUTH, LS_SHOP } from './constants';
import { useDispatch } from 'react-redux';
import { setListShop } from 'store/reducers/shop';
import { useLoginHooks } from 'hooks/login';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const ShopFetcher = () => {
    const isFetched = useRef(false);
    const dispatch = useDispatch();
    const { logOut } = useLoginHooks();

    useEffect(() => {
        if (isFetched.current) {
            return;
        }

        isFetched.current = true;
        const token = localStorage.getItem(LS_AUTH);
        if (!!token) {
            getShopList().then((response) => {
                if (response === null) {
                    logOut();
                    return;
                }

                const list = [];
                response?.shops?.forEach((shop) => {
                    list.push({
                        id: shop.id,
                        name: shop.name,
                        isVerified: shop.is_verified,
                        currency: shop.currency_data || {
                            decimal_num: 0,
                            code: 'Rp',
                            decimal: ',',
                            thousand: '.'
                        },
                        reservationCurrency: shop.reservation_currency_data || {
                            decimal_num: 0,
                            code: 'Rp',
                            decimal: ',',
                            thousand: '.'
                        },
                        coins: shop.shop_loyalty
                    });
                });

                localStorage.setItem(LS_SHOP, JSON.stringify(list));

                dispatch(setListShop({ list }));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

const App = () => (
    <ThemeCustomization>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ShopFetcher />
            <CommonToast />
            <ScrollTop>
                <Routes />
            </ScrollTop>
        </LocalizationProvider>
    </ThemeCustomization>
);

export default App;
